import React, { useRef, useState } from "react";
import { Popover, PopoverAnchor, PopoverContent } from "../ui/popover";

// Song title that reveals its full, exact text when visually truncated.
// mode="hover": hover/focus (console). mode="tap": tap/click toggles, plus mouse hover/focus (guest).
export const TruncatedTitle = ({ title, className = "", mode = "hover", testId }) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  const isTruncated = () => {
    const el = ref.current;
    return !!el && (el.scrollHeight > el.clientHeight + 1 || el.scrollWidth > el.clientWidth + 1);
  };
  const show = () => isTruncated() && setOpen(true);
  const hide = () => setOpen(false);

  const handlers = {
    onFocus: show,
    onBlur: hide,
    onPointerEnter: (e) => e.pointerType === "mouse" && show(),
    onPointerLeave: (e) => e.pointerType === "mouse" && hide(),
  };
  if (mode === "tap") {
    handlers.onClick = (e) => {
      e.stopPropagation();
      if (open) hide();
      else show();
    };
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <p
          ref={ref}
          tabIndex={0}
          aria-label={title}
          data-testid={testId}
          className={`${className} cursor-pointer outline-none focus-visible:underline decoration-secondary/60 underline-offset-2 ${mode === "tap" ? "active:opacity-80" : ""}`}
          {...handlers}
        >
          {title}
        </p>
      </PopoverAnchor>
      <PopoverContent
        side="top"
        align="start"
        sideOffset={6}
        onOpenAutoFocus={(e) => e.preventDefault()}
        onCloseAutoFocus={(e) => e.preventDefault()}
        onInteractOutside={(e) => ref.current?.contains(e.target) && e.preventDefault()}
        className="z-[80] w-auto max-w-[min(22rem,calc(100vw-2rem))] px-3 py-2 text-xs leading-snug font-medium bg-surface-elevated text-foreground border-border shadow-lg pointer-events-none break-words"
        data-testid={testId ? `${testId}-full` : undefined}
      >
        {title}
      </PopoverContent>
    </Popover>
  );
};
